@if (isBrowser) {
  <div
    echarts
    [options]="options()"
    class="chart"
    [style.height.px]="height()"
    role="img"
    [attr.aria-label]="ariaLabel()"
  ></div>
} @else {
  <div class="chart ssr-placeholder" [style.height.px]="height()"></div>
}
